module.exports = __webpack_public_path__ + "img/hair-loss-thinning-hair.8cc04629.jpg";